import classes from "./Vertical.module.css";
import Title from "../../UI/box/title/Title";
import Entity from "../../UI/box/entity/Entity";
import { useEffect, useState, useRef } from "react";
import { useStore } from "./../../../hooks/store";
import parse from "html-react-parser";
import Slider from "./../../slider/CustomSlider";
import { SRLWrapper } from "simple-react-lightbox";
import SimpleReactLightbox from "simple-react-lightbox";
import { Fragment } from "react";

const options = {
  settings: {
    overlayColor: "rgb(104, 104, 104)",
    autoplaySpeed: 1500,
    transitionSpeed: 900,
  },
  buttons: {
    backgroundColor: "black",
    iconColor: "white",
  },
  caption: {
    captionColor: "white",
    captionFontFamily: "Raleway, sans-serif",
    captionFontWeight: "300",
    captionTextTransform: "uppercase",
  },
  progressBar: {
    backgroundColor: "#f2f2f2",
    fillColor: "#000000",
    height: "3px",
    showProgressBar: true,
  },
};

const Vertical = () => {
  const [data, setData] = useState({ metrics: [], title: "" });
  const [loadingData, setLoadingData] = useState(false);
  const state = useStore()[0];
  const typeStyleVertical = useRef(null);
  const colorIconTitle = useRef(null);
  const iconTitleRef = useRef(null);

  useEffect(() => {
    for (let i = 0; i < state.types.length; i++) {
      if (state.types[i].isActive) {
        iconTitleRef.current = state.types[i].icon;
        colorIconTitle.current = {
          backgroundColor: state.types[i].color,
          minWidth: "50px",
          maxWidth: "50px",
          minHeight: "50px",
          maxHeight: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
        };
      }
    }
    if (state.sensors.length > 0) {
      setLoadingData(true);
      for (let i = 0; i < state.sensors.length; i++) {
        if (state.sensors[i].isActive) {
          if (state.sensors[i].typeId === "7") {
            setData({
              historic: {
                category: state.sensors[i].categoryName,
                image: state.sensors[i].thumbnail,
                content: state.sensors[i].content,
                images: state.sensors[i].images,
                // images: [
                //   "https://alexandroupoli.repository.gr/files/asset/b2d3f6e7dc5dd2435bdb3f21127ecf60221e71b8.jpg",
                //   state.sensors[i].thumbnail,
                // ],
              },
              title: state.sensors[i].title,
            });
            typeStyleVertical.current = "POIS";
          } else {
            setData({
              metrics: state.sensors[i].metrics,
              title: state.sensors[i].title,
            });
            typeStyleVertical.current = "Metrics";
          }
        }
      }
    }
  }, [state.sensors]);

  useEffect(() => {
    if (data.title !== "") {
      setLoadingData(false);
    }
  }, [data]);

  const Metrics =
    data.metrics &&
    data.metrics
      .filter((item) => item.value)
      .map((item, index) => (
        <Entity
          key={index}
          icon={item.icon_large}
          content={item.content}
          value={item.value}
          className={classes.gradient_border}
          styleValue={{ fontWeight: "400" }}
        />
      ));

  const POIS = data.historic && (
    <Fragment>
      <SimpleReactLightbox>
        <SRLWrapper options={options}>
          {data.historic.image && (
            <img
              src={data.historic.image}
              alt="thumbnail"
              width="100%"
              style={{ cursor: "pointer" }}
            />
          )}
        </SRLWrapper>
      </SimpleReactLightbox>

      {data.historic.category && (
        <p style={{ fontSize: "14px" }}>
          Κατηγορία: <i>{data.historic.category}</i>
        </p>
      )}
      {data.historic.content && (
        <div style={{ marginTop: "20px", textAlign: "justify" }}>
          {parse(data.historic.content)}
        </div>
      )}

      {data.historic.images.length > 0 && (
        <div className={classes.slider_placeholder}>
          <p className={classes.more_photos_descr}>
            <i>Επιπλέον φωτογραφικό υλικό:</i>
          </p>
          <SimpleReactLightbox>
            <SRLWrapper options={options}>
              <Slider
                settings={{
                  infinite: false,
                }}
              >
                {data.historic.images.map((image, index) => (
                  <div key={index} className={classes.image_placeholder}>
                    <img
                      src={image}
                      alt={data.title}
                      width="100%"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ))}
              </Slider>
            </SRLWrapper>
          </SimpleReactLightbox>
        </div>
      )}
    </Fragment>
  );
  return (
    <div className={classes.info_container}>
      <div className={classes.sticky_title}>
        <Title
          icon={iconTitleRef.current}
          title={data.title}
          styleIcon={colorIconTitle.current}
          className={[classes.info_title, classes.height_unset].join(" ")}
        />
        <hr className={classes.gradient_line_style} />
      </div>

      {!loadingData && typeStyleVertical.current === "Metrics" && Metrics}
      {!loadingData && typeStyleVertical.current === "POIS" && POIS}
    </div>
  );
};

export default Vertical;
